import config from "@/config"
import http from "@/utils/request"

export default {
	getVideoInfoList: {
		url: `${config.API_URL}/lqa-game/system/videoInfo/list`,
		name: "获取视频信息",
		get: async function(data,config={timeout:500000}){
			return await http.get(this.url,data, config);
		}
	},
	getVideoInfoById: {
		url: `${config.API_URL}/lqa-game/system/videoInfo/`,
		name: "获取单个视频详细信息",
		get: async function(id){
			return await http.get(this.url+id);
		}
	},
	getVideoDetailById: {
		url: `${config.API_URL}/lqa-game/system/videoDetail/listByPid?id=`,
		name: "获取单个视频详细信息",
		get: async function(id){
			return await http.get(this.url+id);
		}
	},
	getVideoCutStatus : {
		url: `${config.API_URL}/lqa-game/system/videoDetail/getVideoCutStatus?videoName=`,
		name: "获取单个视频切片状态",
		get: async function(name){
			return await http.get(this.url+name);
		}
	},
	
	cutVideoMethod: {
		url: `${config.API_URL}/lqa-game/system/videoInfo/cutVideo`,
		name: "开始视频切片",
		post: async function(data,config={timeout:500000}){
			return await http.post(this.url,data, config);
		}
	},
	deleteVideoDetail: {
		url: `${config.API_URL}/lqa-game/system/videoDetail/oss/`,
		name: "开始视频切片",
		delete: async function(id,config={timeout:500000}){
			return await http.delete(this.url+id, config);
		}
	},
	
}
